import styled from '@emotion/styled';

export const FormErrorMessage = styled.span`
  margin: 0;
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.danger};
`;

export const FormErrorMessageOnTop = styled.span`
  display: inline-block;
  margin: 0;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.danger};
`;
